<script setup lang="ts">
import { useAuthUser } from '@/helpers/globals';
import { ref, type Ref, onMounted } from 'vue';
import { instance as api } from '@/helpers/api';

const authUser = useAuthUser();
const email: Ref<string> = ref('');
const emailError: Ref<string> = ref('');
const emailSuccess: Ref<string> = ref('');
const egrid: Ref<string> = ref('CH527706802979');
const egridError: Ref<string> = ref('');
const egridSuccess: Ref<string> = ref('');

async function testMail() {
    try {
        emailError.value = '';
        emailSuccess.value = '';
        const res = await api().post('/admin/sendTestEmail', {
            email: email.value
        });
        if (res?.data?.success) {
            emailSuccess.value = 'OK';
        }
    } catch (error) {
        console.error(error);
        emailError.value = String(error);
    }
}

async function testTerris() {
    try {
        egridError.value = '';
        egridSuccess.value = '';
        const res = await api().post('/admin/testTerris', {
            egrid: egrid.value
        });
        if (res?.data?.success) {
            egridSuccess.value = 'OK';
        }
    } catch (error) {
        console.error(error);
        egridError.value = String(error);
    }
}

onMounted(() => {
    if (!email.value) {
        email.value = authUser?.email || '';
    }
});
</script>
<template>
    <div>
        <h4 class="ktg-title-04">{{ $t('connectivity') }}</h4>
        <div class="flex justify-content-start align-content-center mt-2rem">
            <div>
                <ktg-field>
                    <ktg-label for="email">{{ $t('email') }}</ktg-label>

                    <ktg-text-input
                        :value="email"
                        @change="email = $event.target.value"
                        input-id="email"
                        type="email"
                        autofocus
                    >
                    </ktg-text-input>
                </ktg-field>
            </div>
            <ktg-button appearance="tertiary" size="large" type="button" @click="testMail"> Test </ktg-button
            ><ktg-clues appearance="danger" v-if="emailError !== ''">
                <ktg-clue>
                    <ktg-clue-title icon="warning"> {{ emailError }} </ktg-clue-title>
                </ktg-clue>
            </ktg-clues>
            <ktg-clues v-if="emailSuccess" class="ml-2rem">
                <ktg-clue>
                    <ktg-clue-title icon="circle-checked">{{ emailSuccess }}</ktg-clue-title>
                </ktg-clue>
            </ktg-clues>
        </div>
        <div class="flex justify-content-start align-content-center mt-2rem">
            <div>
                <ktg-field>
                    <ktg-label for="email"> TERRIS (EGRID) </ktg-label>

                    <ktg-text-input :value="egrid" input-id="egrid" type="text" autofocus> </ktg-text-input>
                </ktg-field>
            </div>
            <ktg-button appearance="tertiary" size="large" type="button" @click="testTerris"> Test </ktg-button
            ><ktg-clues appearance="danger" v-if="egridError !== ''">
                <ktg-clue>
                    <ktg-clue-title icon="warning"> {{ egridError }} </ktg-clue-title>
                </ktg-clue>
            </ktg-clues>
            <ktg-clues v-if="egridSuccess" class="ml-2rem">
                <ktg-clue>
                    <ktg-clue-title icon="circle-checked">{{ egridSuccess }}</ktg-clue-title>
                </ktg-clue>
            </ktg-clues>
        </div>
    </div>
</template>

<style scoped lang="scss"></style>
